import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareFlightBook', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareFlightBook/${basketKey}`, request)
}

export {post, put}
